import styled, {css} from 'styled-components'

export const StyledLegendDot = styled.div<{$color: string}>(
    ({$color}) => css`
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${$color};
    `
)

export const StyledChartContainer = styled.div`
    flex-shrink: 0;
`

export const StyledChartLegendContainer = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 1fr auto;
        gap: ${spacing * 4}px;
        align-items: center;
    `
)
